import { api } from '@/api';

const createProduct = (product) => {
  return api.post('/api/kyc/v1/editingProduct/product', {
    type: product.type,
    name: product.name,
    title: product.title,
    descriptions: product.descriptions
  });
};
const updateProduct = (product) => {
  const formData = new FormData();
  formData.append('productId', product.id);
  if (product.type) formData.append('type', product.type);
  if (product.name) formData.append('name', product.name);
  if (product.name_RU) formData.append('name_RU', product.name_RU);
  if (product.name_LV) formData.append('name_LV', product.name_LV);
  if (product.title) formData.append('title', product.title);
  if (product.title_RU) formData.append('title_RU', product.title_RU);
  if (product.title_LV) formData.append('title_LV', product.title_LV);
  if (product.descriptions) formData.append('descriptions', product.descriptions);
  if (product.descriptions_RU) formData.append('descriptions_RU', product.descriptions_RU);
  if (product.descriptions_LV) formData.append('descriptions_LV', product.descriptions_LV);
  if (product.typeProduct) formData.append('typeProduct', product.typeProduct);
  if (product.typeProduct_RU) formData.append('typeProduct_RU', product.typeProduct_RU);
  if (product.typeProduct_LV) formData.append('typeProduct_LV', product.typeProduct_LV);
  if (product.interestRate) formData.append('interestRate', product.interestRate);
  if (product.interestRate_RU) formData.append('interestRate_RU', product.interestRate_RU);
  if (product.interestRate_LV) formData.append('interestRate_LV', product.interestRate_LV);
  if (product.isin) formData.append('isin', product.isin);
  if (product.term) formData.append('term', product.term);
  if (product.term_RU) formData.append('term_RU', product.term_RU);
  if (product.term_LV) formData.append('term_LV', product.term_LV);
  if (product.interestPaid) formData.append('interestPaid', product.interestPaid);
  if (product.interestPaid_RU) formData.append('interestPaid_RU', product.interestPaid_RU);
  if (product.interestPaid_LV) formData.append('interestPaid_LV', product.interestPaid_LV);
  if (product.redemption) formData.append('redemption', product.redemption);
  if (product.redemption_RU) formData.append('redemption_RU', product.redemption_RU);
  if (product.redemption_LV) formData.append('redemption_LV', product.redemption_LV);
  if (product.offerPeriodUntil || product.offerPeriodUntil === null)
    formData.append('offerPeriodUntil', product.offerPeriodUntil);
  if (product.processingFee !== undefined) {
    formData.append('processingFee', product.processingFee);
  }
  if (product.stockDeposit !== undefined) {
    formData.append('stockDeposit', product.stockDeposit);
  }
  if (product.minimalAmount) formData.append('minimalAmount', product.minimalAmount);
  if (product.offerAndConditions) formData.append('offerAndConditions', product.offerAndConditions);
  if (product.offerAndConditions_RU)
    formData.append('offerAndConditions_RU', product.offerAndConditions_RU);
  if (product.offerAndConditions_LV)
    formData.append('offerAndConditions_LV', product.offerAndConditions_LV);
  if (product.company) formData.append('company', product.company);
  if (product.company_RU) formData.append('company_RU', product.company_RU);
  if (product.company_LV) formData.append('company_LV', product.company_LV);
  if (product.linkToCentralBankOfLatvia)
    formData.append('linkToCentralBankOfLatvia', product.linkToCentralBankOfLatvia);
  if (product.isRequired !== undefined) {
    formData.append('isRequired', product.isRequired);
  }
  if (product.logoURL) formData.append('logoURL', product.logoURL);

  return api.put('/api/kyc/v1/editingProduct/product', formData);
};

const deleteProduct = (product) => {
  return api.delete('/api/kyc/v1/editingProduct/product', {
    data: { productId: product.id }
  });
};

const addProductDescription = (product) => {
  return api.post('/api/kyc/v1/editingProduct/productDescription', {
    productId: product.productId,
    name: product.name,
    name_RU: product.name_RU,
    name_DE: product.name_DE,
    name_LV: product.name_LV,
    descriptions: product.descriptions,
    descriptions_RU: product.descriptions_RU,
    descriptions_DE: product.descriptions_DE,
    descriptions_LV: product.descriptions_LV
  });
};
const changeProductDescription = (product) => {
  return api.put('/api/kyc/v1/editingProduct/productDescription', {
    productDescriptionId: product.id,
    name: product.name,
    name_RU: product.name_RU,
    name_DE: product.name_DE,
    name_LV: product.name_LV,
    descriptions: product.descriptions,
    descriptions_RU: product.descriptions_RU,
    descriptions_DE: product.descriptions_DE,
    descriptions_LV: product.descriptions_LV
  });
};
const deleteProductDescription = ({ productDescriptionId }) => {
  return api.delete('/api/kyc/v1/editingProduct/productDescription', {
    data: {
      productDescriptionId: productDescriptionId
    }
  });
};
const addProductLink = ({ productId, name, link, name_RU, name_LV, name_DE }) => {
  return api.post('/api/kyc/v1/editingProduct/productLink', {
    productId: productId,
    name: name,
    link: link,
    name_RU: name_RU,
    name_LV: name_LV,
    name_DE: name_DE
  });
};
const changeProductLink = ({ productLinkId, name, url, name_RU, name_LV, name_DE }) => {
  return api.put('/api/kyc/v1/editingProduct/productLink', {
    productLinkId: productLinkId,
    name: name,
    link: url,
    name_RU: name_RU,
    name_LV: name_LV,
    name_DE: name_DE
  });
};
const deleteProductLink = ({ productLinkId }) => {
  return api.delete('/api/kyc/v1/editingProduct/productLink', {
    data: {
      productLinkId: productLinkId
    }
  });
};

const addFileToProduct = ({ file, productId, name, descriptions }) => {
  const formData = new FormData();
  formData.append('productId', productId);
  formData.append('file', file);
  if (name) formData.append('name', name);
  if (descriptions) formData.append('descriptions', descriptions);

  return api.post('/api/kyc/v1/editingProduct/productFileToDownload', formData);
};

const renameFileToProduct = ({ productFileToDownloadId, name, descriptions }) => {
  return api.put('/api/kyc/v1/editingProduct/productFileToDownload', {
    productFileToDownloadId: productFileToDownloadId,
    name: name,
    descriptions: descriptions
  });
};

const deleteFileFromProduct = (productFileToDownloadId) => {
  return api.delete('/api/kyc/v1/editingProduct/productFileToDownload', {
    data: {
      productFileToDownloadId: productFileToDownloadId
    }
  });
};

const createSection = (productId, section) => {
  return api.post('/api/kyc/v1/editingProduct/productSection', {
    productId: productId,
    section: section.section,
    section_RU: section.section_RU,
    section_LV: section.section_LV,
    section_DE: section.section_DE,
    sortOrder: section.sortOrder
  });
};

const updateSection = (section) => {
  return api.put('/api/kyc/v1/editingProduct/productSection', {
    productSectionId: section.id,
    section: section.section,
    section_RU: section.section_RU,
    section_LV: section.section_LV,
    section_DE: section.section_DE,
    sortOrder: section.sortOrder
  });
};

const updateSectionOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingProduct/productSection', {
    productSectionId: id,
    sortOrder: sortOrder
  });
};

const deleteSection = (section) => {
  return api.delete('/api/kyc/v1/editingProduct/productSection', {
    data: { productSectionId: section.id }
  });
};

const createGroup = (group, sectionId) => {
  return api.post('/api/kyc/v1/editingProduct/productGroup', {
    productSectionId: sectionId,
    title: group.title,
    title_RU: group.title_RU,
    title_LV: group.title_LV,
    title_DE: group.title_DE,
    isMultiple: group.isMultiple,
    multipleMin: group.multipleMin,
    multipleMax: group.multipleMax,
    sortOrder: group.sortOrder,
    visibleConditions: group.visibleConditions,
    visibleOperator: group.visibleOperator
  });
};

const updateGroup = (group) => {
  return api.put('/api/kyc/v1/editingProduct/productGroup', {
    productGroupId: group.id,
    title: group.title,
    title_RU: group.title_RU,
    title_LV: group.title_LV,
    title_DE: group.title_DE,
    isMultiple: group.isMultiple,
    multipleMin: group.multipleMin,
    multipleMax: group.multipleMax,
    sortOrder: group.sortOrder,
    visibleConditions: group.visibleConditions,
    visibleOperator: group.visibleOperator
  });
};

const updateGroupOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingProduct/productGroup', {
    productGroupId: id,
    sortOrder: sortOrder
  });
};

const deleteGroup = (group) => {
  return api.delete('/api/kyc/v1/editingProduct/productGroup', {
    data: { productGroupId: group.id }
  });
};

const createQuestion = (question, productGroupId) => {
  return api.post('/api/kyc/v1/editingProduct/productQuestion', {
    productGroupId: productGroupId,
    question: question.question,
    type: question.type,
    question_RU: question.question_RU,
    question_LV: question.question_LV,
    tooltip: question.tooltip,
    tooltip_RU: question.tooltip_RU,
    tooltip_LV: question.tooltip_LV,
    isRequired: question.isRequired,
    sortOrder: question.sortOrder,
    visibleConditions: question.visibleConditions,
    visibleOperator: question.visibleOperator,
    preFilledValue: question.preFilledValue,
    dateForSelect: question.dateForSelect,
    minCountSymbols: question.minCountSymbols,
    maxCountSymbols: question.maxCountSymbols,
    countFirstLetterSymbolsCountry: question.countFirstLetterSymbolsCountry
  });
};

const updateQuestion = (question) => {
  return api.put('/api/kyc/v1/editingProduct/productQuestion', {
    productQuestionId: question.id,
    question: question.question,
    question_RU: question.question_RU,
    question_LV: question.question_LV,
    type: question.type,
    tooltip: question.tooltip,
    tooltip_RU: question.tooltip_RU,
    tooltip_LV: question.tooltip_LV,
    isRequired: question.isRequired,
    sortOrder: question.sortOrder,
    visibleConditions: question.visibleConditions,
    visibleOperator: question.visibleOperator,
    preFilledValue: question.preFilledValue,
    dateForSelect: question.dateForSelect,
    minCountSymbols: question.minCountSymbols,
    maxCountSymbols: question.maxCountSymbols,
    countFirstLetterSymbolsCountry: question.countFirstLetterSymbolsCountry
  });
};

const updateQuestionOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingProduct/productQuestion', {
    productQuestionId: id,
    sortOrder: sortOrder
  });
};

const deleteQuestion = (question) => {
  return api.delete('/api/kyc/v1/editingProduct/productQuestion', {
    data: { productQuestionId: question.id }
  });
};

const createAnswer = (answer, questionId) => {
  return api.post('/api/kyc/v1/editingProduct/productAvailableAnswer', {
    productQuestionId: questionId,
    answer: answer.answer,
    answer_RU: answer.answer_RU,
    answer_LV: answer.answer_LV,
    answer_DE: answer.answer_DE,
    sortOrder: answer.sortOrder,
    points: answer.points
  });
};

const updateAnswer = (answer) => {
  return api.put('/api/kyc/v1/editingProduct/productAvailableAnswer', {
    productAvailableAnswerId: answer.id,
    answer: answer.answer,
    answer_RU: answer.answer_RU,
    answer_LV: answer.answer_LV,
    answer_DE: answer.answer_DE,
    sortOrder: answer.sortOrder,
    points: answer.points
  });
};

const updateAnswerOrder = ({ id, sortOrder }) => {
  return api.put('/api/kyc/v1/editingProduct/productAvailableAnswer', {
    productAvailableAnswerId: id,
    sortOrder: sortOrder
  });
};

const deleteAnswer = (answer) => {
  return api.delete('/api/kyc/v1/editingProduct/productAvailableAnswer', {
    data: { productAvailableAnswerId: answer.id }
  });
};

export const ConstructorApi = {
  createProduct,
  updateProduct,
  deleteProduct,
  addProductDescription,
  changeProductDescription,
  deleteProductDescription,
  addProductLink,
  changeProductLink,
  deleteProductLink,
  addFileToProduct,
  renameFileToProduct,
  deleteFileFromProduct,
  createSection,
  updateSection,
  updateSectionOrder,
  deleteSection,
  createGroup,
  updateGroup,
  updateGroupOrder,
  deleteGroup,
  createQuestion,
  updateQuestion,
  updateQuestionOrder,
  deleteQuestion,
  createAnswer,
  updateAnswer,
  updateAnswerOrder,
  deleteAnswer
};
